module.exports = __webpack_public_path__ + "img/bottom_3.cacd4d0c.jpg";